import axios from 'axios';
import { API_BASE_URL, ACCESS_KEY, REFRESH_KEY } from '../constants/common';
import toast from 'react-hot-toast';
import { browserName, browserVersion } from 'react-device-detect';
import RefreshTokenService from '../services/RefreshToken';

const service =  axios.create({
    baseURL: API_BASE_URL,
    headers: {
        'device-type': "browser",
        'device-id': "1",
        'os-type': browserName,
        'os-version': browserVersion
    }
});

function clearStorageAndRefresh() {
    localStorage.clear()
    window.location.reload(true);
}

service.interceptors.request.use((config) => {
    const accessToken = localStorage.getItem(ACCESS_KEY);

    if(accessToken) {
        if(!config.headers['Authorization']) {
            config.headers['Authorization'] = `Bearer ${accessToken}`;
        }
    }
    return config;
}, error => {
    // toast.error("An error has occured");
    return Promise.reject(error)
})

let refreshPromise = null;
const refreshAccessToken = () => {
    if (!refreshPromise) {
        const refreshToken = localStorage.getItem(REFRESH_KEY);
        refreshPromise = RefreshTokenService.getRenualAccessToken({refresh_token: refreshToken})
            .then((refreshResponse) => {
                if (refreshResponse.success) {
                    const newAccessKey = refreshResponse.response.access_token;
                    localStorage.setItem(ACCESS_KEY, newAccessKey);
                    if (refreshResponse.response.refresh_token) {
                        localStorage.setItem(REFRESH_KEY, refreshResponse.response.refresh_token);
                    }
                }
                return refreshResponse;
            })
            .finally(() => {
                refreshPromise = null;
            });
    }
    return refreshPromise;
};

service.interceptors.response.use(response => response.data,
        async (error) => {
            const prevRequest = error?.config;
            console.log("Hello world", error)
            const isRefreshRequest = prevRequest?.url?.includes('/refresh');
            if(  error?.response?.status === 401 &&
                !error.request.responseURL.includes('/login') &&
                !isRefreshRequest) {
                prevRequest.sent = false;
                const refreshToken = localStorage.getItem(REFRESH_KEY)
                if(!refreshToken) {
                    clearStorageAndRefresh();
                }
                try {
                    const refreshResponse = await RefreshTokenService.getRenualAccessToken({
                        refresh_token: refreshToken,  
                        os_type: browserName,
                        os_version: browserVersion,
                        device_id: '1',
                        device_type: 'browser',});

                    if (refreshResponse.success) {
                        localStorage.setItem(ACCESS_KEY, refreshResponse.access_token);
                        localStorage.setItem(REFRESH_KEY, refreshResponse.refresh_token);
                        prevRequest.headers['Authorization'] = `Bearer ${refreshResponse.access_token}`;
                        return service(prevRequest);
                    } else {
                        clearStorageAndRefresh();
                        toast.error("Session has expired. Try login again");
                    }
                } catch (error) {
                    clearStorageAndRefresh();
                    // toast.error("Session has expired. Try login again");
                }

            }

            if(error?.response?.status === 401 && isRefreshRequest) {
                localStorage.clear()
                window.location.reload(true);
                toast.error("Session has expired.... Try login again");
            }

            if(error?.response?.status === 400) {

                // return error.response.data;
                return {
                    success: false,
                    message: "Invalid request. Please verify the submitted data and try again."
                };
            }
            // localStorage.clear()
            // toast.error("An error has occured");
            return Promise.reject(error.response.data);
        })

export default service

export const axiosPrivate = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        'device-type': "android",
        'device-id': "",
        'os-type': `${browserName} V${browserVersion}`,
    }
});